var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRound64AError = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 60",
  ref: ref
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 30,
  r: 11,
  fill: "#464D57",
  stroke: "#DB5C67",
  strokeWidth: 2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M25 4h10l.752 8.274A2.5 2.5 0 0 1 33.262 15h-6.524a2.5 2.5 0 0 1-2.49-2.726L25 4Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#DB5C67",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m24 6 .223-.445A2.813 2.813 0 0 1 26.738 4h6.524c1.065 0 2.039.602 2.515 1.555L36 6"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M35 56H25l-.752-8.274A2.5 2.5 0 0 1 26.738 45h6.524a2.5 2.5 0 0 1 2.49 2.726L35 56Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#DB5C67",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m36 54-.223.445A2.813 2.813 0 0 1 33.262 56h-6.524a2.813 2.813 0 0 1-2.515-1.555L24 54"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "m50.017 12.67 5 8.66-6.79 4.788a2.5 2.5 0 0 1-3.605-.793l-3.263-5.65a2.5 2.5 0 0 1 1.116-3.52l7.542-3.485Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  stroke: "#DB5C67",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m47.785 12.804.497-.03a2.812 2.812 0 0 1 2.604 1.401l3.261 5.65a2.813 2.813 0 0 1-.088 2.956l-.274.415"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "m9.983 47.33-5-8.66 6.79-4.788a2.5 2.5 0 0 1 3.606.793l3.262 5.65a2.5 2.5 0 0 1-1.116 3.52L9.983 47.33Z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  stroke: "#DB5C67",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m12.215 47.196-.496.03a2.812 2.812 0 0 1-2.605-1.401l-3.261-5.65a2.813 2.813 0 0 1 .088-2.956l.274-.415"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "m55.017 38.67-5 8.66-7.542-3.486a2.5 2.5 0 0 1-1.116-3.519l3.262-5.65a2.5 2.5 0 0 1 3.606-.793l6.79 4.788Z"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  stroke: "#DB5C67",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m53.785 36.804.274.415c.587.89.621 2.033.089 2.956l-3.262 5.65a2.812 2.812 0 0 1-2.605 1.4l-.496-.029"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "m4.983 21.33 5-8.66 7.542 3.486a2.5 2.5 0 0 1 1.116 3.519l-3.262 5.65a2.5 2.5 0 0 1-3.606.794l-6.79-4.789Z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  stroke: "#DB5C67",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m6.215 23.196-.274-.415a2.812 2.812 0 0 1-.088-2.956l3.261-5.65a2.812 2.812 0 0 1 2.604-1.4l.498.029"
})));
SvgRound64AError.viewBox = '0 0 60 60';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRound64AError);
export default ForwardRef;